// src/hooks/useCustomerEquipment.ts
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { CustomerEquipment } from '@/types/service';

export function useCustomerEquipment(customerId: string | null) {
  const { company } = useAuth();

  return useQuery({
    queryKey: ['customer-equipment', company?.id, customerId],
    queryFn: async () => {
      if (!company?.id || !customerId) return [];

      const { data, error } = await supabase.rpc('get_customer_equipment', {
        p_company_id:  company.id,
        p_customer_id: customerId,
      });

      if (error) throw error;
      return (data ?? []) as CustomerEquipment[];
    },
    enabled: !!company?.id && !!customerId,
  });
}
